interface Route<T extends `/${string}`> {
  path: T;
  authenticated: boolean;
  isAuthPath?: true;
  sidebar?: boolean;
  title?: string;
}

export const ROUTES = {
  // noauth
  landing: {
    path: "/",
    authenticated: false,
    sidebar: false,
    title: "tilliX",
  },
  faq: {
    path: "/faq",
    authenticated: false,
    sidebar: false,
    title: "FAQ",
  },
  signIn: {
    path: "/sign-in",
    authenticated: false,
    isAuthPath: true,
    sidebar: false,
    title: "Sign In",
  },
  signUp: {
    path: "/sign-up",
    authenticated: false,
    isAuthPath: true,
    sidebar: false,
    title: "Sign Up",
  },
  forgotPassword: {
    path: "/forgot-password",
    authenticated: false,
    isAuthPath: true,
    sidebar: false,
    title: "Forgot Password",
  },
  quickPay: {
    path: "/quick-pay",
    authenticated: false,
    sidebar: false,
    title: "Quick Pay",
  },

  // auth
  dashboard: {
    path: "/",
    authenticated: true,
    sidebar: true,
    title: "Dashboard",
  },
  dashboardPage: {
    path: "/dashboard",
    authenticated: true,
    sidebar: true,
    title: "Dashboard",
  },
  onboarding: {
    path: "/onboarding",
    authenticated: true, // but user does not exist in tilliX DB yet
    sidebar: false,
    title: "Onboarding",
  },
  invoices: {
    path: "/invoices",
    authenticated: true,
    sidebar: true,
    title: "Invoices",
  },
  paymentMethods: {
    path: "/payment-methods",
    authenticated: true,
    sidebar: true,
    title: "Payment Methods",
  },
  notifications: {
    path: "/notifications",
    authenticated: true,
    sidebar: true,
    title: "Notifications",
  },
  pay: {
    path: "/pay",
    authenticated: true,
    sidebar: true,
    title: "Make A Payment",
  },
  paymentHistory: {
    path: "/payment-history",
    authenticated: true,
    sidebar: true,
    title: "Payment History",
  },
  analytics: {
    path: "/analytics",
    authenticated: true,
    sidebar: true,
    title: "Analytics",
  },
  meters: {
    path: "/meter-details",
    authenticated: true,
    sidebar: true,
    title: "Meter Details",
  },
  consumption: {
    path: "/consumption",
    authenticated: true,
    sidebar: true,
    title: "Consumption",
  },
  accounts: {
    path: "/accounts",
    authenticated: true,
    sidebar: true,
    title: "Accounts",
  },
  settings: {
    path: "/settings",
    authenticated: true,
    sidebar: true,
    title: "Settings",
  },
  programs: {
    path: "/programs",
    authenticated: true,
    sidebar: true,
    title: "Programs",
  },
  paymentConfirmation: {
    path: "/payment",
    authenticated: true,
    sidebar: true,
    title: "Payment Confirmation",
  },
} as const satisfies Record<string, Route<`/${string}`>>;

export const AUTH_ROUTES = Object.fromEntries(
  Object.entries(ROUTES).filter(([, route]) => route.authenticated),
);
export const authenticatedPaths = Object.values(AUTH_ROUTES).map(
  (route) => route.path,
) as string[];

export const NOAUTH_ROUTES = Object.fromEntries(
  Object.entries(ROUTES).filter(([, route]) => !route.authenticated),
);
export const unauthenticatedPaths = Object.values(NOAUTH_ROUTES).map(
  (route) => route.path,
) as string[];

export const SIDEBAR_ROUTES = Object.fromEntries(
  Object.entries(ROUTES).filter(([, route]) => route.sidebar === true),
);
export const sidebarPaths = Object.values(SIDEBAR_ROUTES).map(
  (route) => route.path,
) as string[];
